// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".codeList[data-v-896a1048] {\n  float: left;\n  color: #28ca00;\n}\n.codeList .item[data-v-896a1048] {\n    margin: 10px;\n    display: inline-block;\n}\n.updataButton[data-v-896a1048] {\n  cursor: pointer;\n  width: 250px;\n  height: 50px;\n  background: #00ccff;\n  overflow: hidden;\n  position: relative;\n  border-radius: 10px;\n  line-height: 50px;\n  text-align: center;\n  color: white;\n  font-size: 20px;\n  font-weight: 900;\n  margin-left: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
